import axios from "axios";
import {
  GET_INDUSTRY_EPISODES,
  GET_INDUSTRY_EPISODE,
  INDUSTRY_ERROR,
} from "./types";

// Get industry of week episodes
export const getIndustryEpisodes = () => async (dispatch) => {
  try {
    const res = await axios.get("/api/industryofweek");

    dispatch({
      type: GET_INDUSTRY_EPISODES,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: INDUSTRY_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get recent industry episode
export const getIndustryRecentEpisode = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/industryofweek/recent`);

    dispatch({
      type: GET_INDUSTRY_EPISODE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: INDUSTRY_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get industry of week episode
export const getIndustryEpisode = (industryname) => async (dispatch) => {
  try {
    const res = await axios.get(`/api/industryofweek/${industryname}`);

    dispatch({
      type: GET_INDUSTRY_EPISODE,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: INDUSTRY_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};
